(function () {
  'use strict';

  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'firebase',
      'chart.js'
    );

  angular.module('MktzapApp.Controllers')
    .config(['ChartJsProvider', function (ChartJsProvider) {
      ChartJsProvider.setOptions('bar', {
        chartColors: ['#F6BB42', '#3BAFDA', '#37BC9B', '#DA4453', '#97bbcd', '#dcdcdc', '#f7464a', '#46bfbd', '#fdb45c', '#949fb1', '#4d5360'],
        responsive: true,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 10
          }
        },
        scales: {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        line: {
          showLines: false
        }
      });
    }])
    .controller('DashboardController', dashboard)

  dashboard.$inject = ['$scope', '$rootScope', 'DashboardService', '$interval', 'NotificationFactory', '$firebaseObject'];

  function dashboard ($scope, $rootScope, DashboardService, $interval, NotificationFactory, $firebaseObject) {
    var vm = this;
    vm.labels = [''];
    Firebase.goOnline();
    $scope.$on('$destroy', function () {
      Firebase.goOffline();
    });

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    var dashboardRef;
    var counter = angular.element('span#counter');
    var favicon = {
      'email': 'fa-envelope-o',
      'facebook': 'fa-facebook',
      'webchat': 'fa-comment',
      'whatsappweb': 'fa-whatsapp',
      'sms': 'fa-mobile',
      'telegrambot': 'fa-paper-plane-o'
    };

    dashboardRef = new Firebase(firebase_url + '/dashboard/' + $rootScope.user_data.company_id);
    var fbObject = $firebaseObject(dashboardRef);
    fbObject.$loaded().then(function () {
      showDashboard(fbObject);
      fbObject.$watch(function () {
        showDashboard(fbObject);
      });
    });

    function showDashboard (obj) {
      var channels = obj.channels;
      vm.updated_at = obj.updated_at;
      vm.channels = channels;
      vm.size = 100 / Object.keys(channels).length;
      angular.forEach(channels, function (value, key) {
        if (value instanceof Object) {
          vm.channels[key].favicon = favicon[key];
          if (value.counters) {
            vm.channels[key].pie = {
              type: 'PieChart',
              data: { 'cols': [
                { id: 't', label: 'Topping', type: 'string' },
                { id: 's', label: 'Slices', type: 'number' }
              ],
              'rows': [
                { c: [
                  { v: 'Não Atendidos' },
                  { v: parseInt(value.counters.line) }
                ] },
                { c: [
                  { v: 'Em Atendimento' },
                  { v: parseInt(value.counters.distributed) }
                ] },
                { c: [
                  { v: 'Finalizados' },
                  { v: parseInt(value.counters.closed) }
                ] }
              ] },
              options: {
                legend: {
                  alignment: 'center',
                  position: 'bottom'
                },
                pieStartAngle: 100,
                sliceVisibilityThreshold: 0.0,
                colors: ['#DA4453', '#3BAFDA', '#37BC9B'],
                tooltip: {
                  ignoreBounds: true,
                  showColorCode: true
                },
                animation: {
                  duration: 1000,
                  easing: 'linear',
                  startup: true
                },
                width: '100%',
                height: 250,
                chartArea: {
                  width: '90%',
                  height: '70%'
                }
              }
            };
          } else {
            vm.channels[key].pie = {
              type: 'PieChart',
              data: { 'cols': [
                { id: 't', label: 'Topping', type: 'string' },
                { id: 's', label: 'Slices', type: 'number' }
              ],
              'rows': [] }
            };
          }
          if (value.performance) {
            var rowsPerformance = []; var rowsLength = value.performance.length;
            for (var i = 0; i < rowsLength; i++) {
              rowsPerformance.push({
                c: [
                  { v: value.performance[i].key },
                  { v: parseInt(value.performance[i].value) }
                ]
              });
            }

            vm.channels[key].performance = {
              type: 'PieChart',
              data: { 'cols': [
                { id: 't', label: 'Topping', type: 'string' },
                { id: 's', label: 'Slices', type: 'number' }
              ],
              'rows': rowsPerformance },
              options: {
                legend: {
                  alignment: 'center',
                  position: 'bottom'
                },
                pieStartAngle: 100,
                sliceVisibilityThreshold: 0.0,
                colors: ['#F6BB42', '#3BAFDA', '#37BC9B', '#DA4453', '#97bbcd', '#dcdcdc', '#f7464a', '#46bfbd', '#fdb45c', '#949fb1', '#4d5360'],
                tooltip: {
                  ignoreBounds: true,
                  showColorCode: true
                },
                animation: {
                  duration: 1000,
                  easing: 'linear',
                  startup: true
                },
                width: '100%',
                height: 250,
                chartArea: {
                  width: '90%',
                  height: '70%'
                }
              }
            };
          } else {
            vm.channels[key].bar = {};
          }
        }
      });
      timerCount();
    }

    function timerCount () {
      var d_moment = moment(vm.updated_at);
      counter.html(d_moment.fromNow());
      if (moment().diff(d_moment, 'minutes') >= 15) {
        errorHandler(null, 'Erro ao atualizar dados do Dashboard, contate o suporte!');
      }
    }

    vm.fullScreen = function () {
      var nav = angular.element('div.side-nav');
      var content = angular.element('div.dynamic-content');
      if (nav.is(':visible')) {
        content.removeClass('large-21');
        content.addClass('large-24');
      } else {
        content.removeClass('large-24');
        content.addClass('large-21');
      }
      nav.toggle();
    }

    function errorHandler (data, override_message) {
      var message = 'Erro. Tente novamente!';
      if (override_message) {
        message = override_message;
      } else {
        if (data.data && data.data.message) {
          message = data.data.message;
        }
      }
      notifSet.addNotification({ title: 'Erro!', content: message, autoclose: '3000', color: 'alert' });
    }

    function successHandler (data, override_message) {
      var message = 'Os dados foram salvos com sucesso.';
      if (override_message) {
        message = override_message
      } else {
        if (data && data.data && data.data.message) {
          message = data.data.message;
        }
      }
      notifSet.addNotification({ title: 'Sucesso!', content: message, autoclose: '3000', color: 'success' });
    }

    function array_column (array, key, group) {
      var result = [];
      $.map(array, function (x, y) {
        var teste = [];
        if (group) {
          teste.push(parseInt(x[key]));
          result.push(teste);
        } else {
          result.push(x[key]);
        }
      });
      return result;
    }
  }
})();
